import {
  NAReportIcon,
  OKReportIcon
} from '../../../components/svg/svg.component'
import { StyledTd } from './components/Table/table.styled'
import { CenteredContent, VesselName } from './daily-production.styled'

export const customCellOKorNot = (props) => {
  return (
    <StyledTd
      style={{ width: props.width }}
      id={`m_grid_cell_${props.field}_${props.dataIndex}`}
    >
      <CenteredContent>
        {props.dataItem[props.field] === 'N/A' ? (
          <NAReportIcon />
        ) : (
          <OKReportIcon />
        )}
      </CenteredContent>
    </StyledTd>
  )
}

export const customName = (props) => {
  return (
    <StyledTd
      isSticky
      left='80px'
      style={{ width: props.width }}
      id={`m_grid_cell_${props.field}_${props.dataIndex}`}
    >
      <VesselName>{props.dataItem[props.field] || '-'}</VesselName>
    </StyledTd>
  )
}

export const numberCell = (props) => {
  return (
    <StyledTd
      isSticky
      left='0px'
      style={{ width: props.width }}
      id={`m_grid_cell_${props.field}_${props.dataIndex}`}
    >
      <CenteredContent>{props.dataIndex + 1}</CenteredContent>
    </StyledTd>
  )
}

export const customServiceRequest = (props) => {
  return (
    <StyledTd
      isSticky
      left='380px' // 80px (No) + 300px (Vessel Name)
      style={{ width: props.width }}
      id={`m_grid_cell_${props.field}_${props.dataIndex}`}
    >
      <VesselName>{props.dataItem[props.field] || '-'}</VesselName>
    </StyledTd>
  )
}
